export enum StructureStatusEnum {
  outgoing = 'HSS1',
  retaining = 'HSS2',
  incoming = 'HSS3',
  executor = 'EXE',
  deputy = 'DEP',
  administrator = 'ADM',
}